import styled from 'styled-components';
import {
  Row,
  Card,
  Collapse,
  Button,
  Input,
  Select,
  Typography,
  DatePicker,
  Divider,
} from 'antd';

import colors from '../../../styles/colors';

const { Panel } = Collapse;
const { Text } = Typography;
const { RangePicker } = DatePicker;

export const CollapseFiltro = styled(Collapse)`
  position: absolute;
  z-index: 99;
  min-width: 98%;
  margin-bottom: 22px;
  border: none;
  .ant-collapse,
  .ant-collapse-item {
    border: none;
  }
`;

export const CollapsePanel = styled(Panel)`
  height: 48px;
  background: #f2f2f2;
  border-radius: 2px;
  border: none;

  .ant-collapse-header {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    .ant-collapse-extra {
      margin-left: 0 !important;
    }
  }

  .ant-collapse-item:last-child,
  .ant-collapse-content {
    border: none;
    background: #f3f3f3;
    box-shadow: 0px 10px 8px rgba(112, 112, 112, 0.15);
    border-radius: 0px 0px 16px 16px !important;
  }
`;
export const ContentFiltro = styled(Card)`
  width: 100%;
  height: 280px;
  border: none;
  background: #f3f3f3;
  .ant-card-body {
    padding: 37px 22px 24px 22px;
    background: #f3f3f3;
  }
`;

export const LabelInput = styled(Text)`
  color: #0d3549;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  padding-bottom: 8px;
`;

export const BoxInput = styled(Row)`
  flex-direction: column;
`;

export const InputItem = styled(Input)`
  border: none;
  background: #ffffff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  padding: 6px 8px;
  width: 60%;
`;

export const SelectItem = styled(Select)`
  border: none;
  background: #ffffff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  width: 60%;
  z-index: 99999;
  .ant-select:not(.ant-select-customize-input),
  .ant-select-selector {
    border: none !important;
  }
`;

export const BtnFiltrar = styled(Button)`
  background-color: ${colors.verde} !important;
  color: ${colors.branco} !important;
  border-radius: 2px !important;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  border: none;
  height: auto;
  padding: 6px 10px;
  img {
    margin-right: 9px;
  }
  :disabled {
    background-color: #c2ccd1 !important;
  }
`;

export const DateFilter = styled(RangePicker)`
  border: none;
  background: #ffffff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  padding: 6px 8px;
  width: 60%;
  z-index: 99999;
`;

export const ContainerExter = styled(Row)`
  height: 99%;
`;

export const TitleExtra = styled(Text)`
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: ${props => props.color || colors.blackText};
`;

export const DividerExtra = styled(Divider)`
  border-color: #c4c4c4;
  height: 1.4em;
  margin: 0 2em;
`;
